export type SetDocumentTitleContext = {
  project?: string;
  platform?: string;
};

const buildTitleSuffix = (context?: SetDocumentTitleContext): string | undefined => {
  if (!context) {
    return undefined;
  }

  const title: string[] = [];

  if (context.project && context.project.trim() !== context.platform?.trim()) {
    title.push(context.project);
  }

  if (context.platform) {
    title.push(context.platform);
  }

  return title.length ? title.join(' - ') : undefined;
};

export const setDocumentTitle = (title: string, context?: SetDocumentTitleContext) => {
  const base = buildTitleSuffix(context);

  if (!base) {
    document.title = title;

    return;
  }

  if (!title) {
    document.title = base;

    return;
  }

  document.title = `${title} - ${base}`;
};
